import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-gesundheit',
  templateUrl: './gesundheit.component.html',
  styleUrls: ['./gesundheit.component.css']
})
export class GesundheitComponent {



}
